
import Vue from "vue";
// eslint-disable-next-line
const ConfirmDlg: any = Vue.extend({
  name: "ConfirmDlg",
  props: {
    labelOk: {
      type: String,
      default: "Ok",
    },
    labelCancel: {
      type: String,
      default: "Abbruch",
    },
  },
  data() {
    return {
      dialog: false,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      resolve: (v: boolean | string) => {},
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      reject: (v: boolean) => {},
      message: "",
      title: "",
      options: {
        textColor: "grey lighten-3",
        width: 400,
        zIndex: 200,
        noconfirm: false,
        textOk: this.labelOk,
        textCancel: this.labelCancel,
        secondOkButton: false,
        textSecondOkButton: "",
      },
    };
  },

  methods: {
    // eslint-disable-next-line
    open(title: string, message: string, options: any) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    secondOption() {
      this.resolve("secondOk");
      this.dialog = false;
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
});

export default ConfirmDlg;
